import { http } from "@inertiajs/core";
import axios from "axios";

export const AIRIE_XSRF_COOKIE_NAME = "AIRIE-XSRF-TOKEN";
export const CSRF_HEADER_NAME = "X-CSRF-TOKEN";

http.setClient({
  xsrfCookieName: AIRIE_XSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
});

axios.defaults.xsrfCookieName = AIRIE_XSRF_COOKIE_NAME;
axios.defaults.xsrfHeaderName = CSRF_HEADER_NAME;

axios.interceptors.request.use((config) => {
  const match = window.location.pathname.match(/^\/w\/([^/]+)/);
  const companySlug = match?.[1];

  if (companySlug) {
    config.headers.set?.("x-org", companySlug);
  }

  return config;
});

/** Reads a cookie value by name (the CSRF token lives in `AIRIE-XSRF-TOKEN`). */
function readCookie(name: string): string | null {
  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = document.cookie.split("; ").find((entry) => entry.startsWith(prefix));
  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null;
}

/**
 * Headers a plain `fetch` POST must attach to satisfy the same session + CSRF +
 * tenant contract Inertia/axios apply automatically: the `X-CSRF-TOKEN` echoed
 * from the readable cookie and the `x-org` workspace slug. Use for fire-and-forget
 * beacons that must NOT go through Inertia's interruptible request stream.
 */
export function csrfFetchHeaders(): Record<string, string> {
  const headers: Record<string, string> = { "X-Requested-With": "XMLHttpRequest" };
  const token = readCookie(AIRIE_XSRF_COOKIE_NAME);
  if (token) {
    headers[CSRF_HEADER_NAME] = token;
  }
  const slug = window.location.pathname.match(/^\/w\/([^/]+)/)?.[1];
  if (slug) {
    headers["x-org"] = slug;
  }
  return headers;
}
